import { render, staticRenderFns } from "./SettlementsContractActions.vue?vue&type=template&id=38ca4d4c&"
import script from "./SettlementsContractActions.vue?vue&type=script&lang=js&"
export * from "./SettlementsContractActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports